import { isSupplyMonitoringEventsEnabled } from 'common/js/supply-monitoring-events-enabling';
import globalConfig from '../../config';
import { sendTrack } from '../../TrackAnalyticsHelper';
import { reaction } from '../../utils/preact-utils';
import { RootStore } from '../root.store';
import { HeavyAdService } from 'common/services/heavy-ad-service';

export class HeavyAdHandler {
  constructor() {
    const formatConfig = RootStore.getInstance().configStore.config;
    if (!isSupplyMonitoringEventsEnabled(formatConfig)) return;

    this.handle();
  }

  handle() {
    if (window.isOgyPreview) return;
    if (!window.frameElement) return;

    const heavyAdService = new HeavyAdService(
      (window.frameElement as unknown) as HTMLIFrameElement,
      () => {
        const adContext = RootStore.getInstance().adContextStore.adContext;
        if (!adContext) return;

        this._reportHeavyAdIntervention(adContext);

        const adContainerStore = RootStore.getInstance().adContainerStore;
        if (
          adContainerStore &&
          adContainerStore.isReady &&
          adContainerStore.isReady.value === false
        ) {
          adContainerStore.unloadFormat && adContainerStore.unloadFormat();
        }
      }
    );

    heavyAdService.listenToHeavyAdIntervention();

    this._setupVideoCompletionObserver(heavyAdService);
  }

  _reportHeavyAdIntervention(adContext: AdContext) {
    const {
      campaignId,
      creativeId,
      advertiserId,
      impressionId,
      adUnitType
    } = adContext;

    const heavyAdQueryParams = {
      e_campaign_id: campaignId,
      e_creative_id: creativeId != null ? creativeId.toString() : '',
      video_event: 'heavy_ad_intervention',
      advertiser_id: advertiserId,
      e_advert_id: impressionId,
      app_ssp: 'ogury',
      ad_unit_type: adUnitType ?? ''
    };

    const heavyAdMonitoringEndpoint = new URL(
      globalConfig.MS_ADS_MONITORING_EVENTS_URL + '/video'
    );
    heavyAdMonitoringEndpoint.search = new URLSearchParams(
      heavyAdQueryParams
    ).toString();

    sendTrack(heavyAdMonitoringEndpoint.toString());
  }

  _setupVideoCompletionObserver(heavyAdService: HeavyAdService) {
    const destroyHeavyAdHandler = reaction(
      () => RootStore.getInstance().videoStore.isVideoCompleted.value,
      isVideoCompleted => {
        if (isVideoCompleted) {
          heavyAdService.destroy();
          destroyHeavyAdHandler();
        }
      }
    );
  }
}
